namespace distill.dashboards {
    export class GridStackCanvas extends appn.designerv2.CanvasBase {
        _grid!: GridStack;
        _gridOptions!: GridStackOptions;

        constructor(options: GridStackOptions) {
            super();
            this._gridOptions = options;
        }

        render(design: IDesign) {
            if (this._grid)
                this._grid.destroy();

            // The workspace DOM is rebuilt below, so dispose the charts cached against the old
            // elements - otherwise a reused instance renders into a removed container and its
            // tooltip throws.
            charts.disposeAll();

            const $workspace = $('.workspace');
            $workspace.empty();

            design?.components.forEach((component: IComponent) => {
                const componentEl = this.createComponentElement(component);
                $workspace.append(componentEl);
            });

            this._grid = GridStack.init(this._gridOptions, $workspace.find('.grid-stack').get(0));
            this.attachGridEvents();
        }
        
        bindDragIn() {
            GridStack.setupDragIn('.toolButton:not(.upgradeReq)', {
                appendTo: 'body',
                helper: 'clone'
            });
        }

        attachGridEvents(): void {
            this._grid.on('added', (event: Event, items: any[]) => {
                items.forEach(item => {
                    const el = item.el as HTMLElement;
                    if (!el.classList.contains('toolButton'))
                        return;
                    
                    el.classList.remove('toolButton');
                    const componentType = el.getAttribute('rel');
                    if (!componentType)
                        return;

                    const gs_w = Number(el.getAttribute('gs-w'));
                    const gs_h = Number(el.getAttribute('gs-h'));
                    const newComponent = designer.addComponent(componentType, {
                        x: item.x ?? 0, y: item.y ?? 0, w: item.w ?? gs_w ?? 4, h: item.h ?? gs_h ?? 4
                    });

                    if (!newComponent)
                        return;

                    let newComponentElement = this.createComponentElement(newComponent);
                    this._grid.removeWidget(el);
                    this._grid.addWidget(newComponentElement[0]);
                    $('.component.selected').removeClass('selected');
                    newComponentElement.addClass('selected');
                    designer.setSelectedComponent(newComponent.id);
                });
            });

            this._grid.on('change', (event: Event, items: any[]) => {
                items?.forEach(item => {
                    if (item.id)
                        designer.updateComponentPosition(item.id, {x: item.x, y: item.y, w: item.w, h: item.h});
                });
            });

            this._grid.on('removed', (event: Event, items: any[]) => {
                items?.forEach(item => {
                    if (item.id)
                        designer.deleteComponent(item.id);
                });
            });
        }

        onCreateComponentElement(component: IComponent, $template:JQuery<HTMLElement>)
        {
            $template.attr('gs-id', component.id);
            if (component.gridPosition) {
                $template.attr('gs-x', component.gridPosition.x);
                $template.attr('gs-y', component.gridPosition.y);
                $template.attr('gs-w', component.gridPosition.w);
                $template.attr('gs-h', component.gridPosition.h);
            }
        }
        
        onUpdateComponentElement(element: JQuery, component: IComponent): void {
            if (component.children && component.children.length > 0) {
                const groupGridStack = element.find('.grid-stack');
                groupGridStack.empty();
                component.children.forEach(childComponent => {
                    const childElement = this.createComponentElement(childComponent);
                    groupGridStack.append(childElement);
                });
            }

            const dashComp = component as IDashboardComponent;
            const $header = element.find('.card-header');
            if ($header.length) {
                const headerBg = dashComp.styling?.headerBgColor;
                if (headerBg && headerBg !== 'transparent')
                    $header.css('background-color', headerBg);
                else
                    $header.css('background-color', '');
            }
        }
        
        removeComponent(componentId: string | undefined) {
            if (componentId && this._grid) {
                const el = document.getElementById(componentId);
                if (el)
                    this._grid.removeWidget(el);
            }
        }
    }
}
